import { cssProps } from '@oracle/oraclejet-cssprops';

// FIXME: Revert after 15.0 release
// import { style } from '@vanilla-extract/css';

const textAlignStyles = {
  start: cssProps`${{
    textAlign: 'start'
  }}`,

  end: cssProps`${{
    textAlign: 'end'
  }}`,

  right: cssProps`${{
    textAlign: 'right'
  }}`
};

export { textAlignStyles };
